export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <g clip-path="url(#a)">
    <path fill="#C35700" d="M4.67.538a.972.972 0 0 1 1.74 0l4.592 8.055a.972.972 0 0 1-.87 1.407H.975a.972.972 0 0 1-.87-1.406L4.67.538Zm.883 6.587a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875Zm0-5.547a.75.75 0 0 0-.75.75v2.777l.004.078a.75.75 0 0 0 1.492 0l.004-.078V2.328a.75.75 0 0 0-.75-.75Z"/>
    <path fill="currentcolor" d="M12.727 2a2 2 0 0 1 1.365.537l5.272 4.917A2 2 0 0 1 20 8.916V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8.938h1.5V20a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V9.447h-4.791a1.75 1.75 0 0 1-1.75-1.75V3.5h-2.02L9.081 2h3.645ZM10 17.25a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5h2Zm2.642-5.438a.75.75 0 0 1 1.06 0l2.828 2.83a.75.75 0 0 1 0 1.06l-2.828 2.828a.75.75 0 0 1-1.06-1.06l1.72-1.72H8a.75.75 0 0 1 0-1.5h6.018l-1.376-1.377a.75.75 0 0 1 0-1.06ZM10 11.25a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5h2Zm3.459-3.553c0 .138.112.25.25.25h3.984L13.46 3.998v3.7Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path fill="#fff" d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
`;
